module.exports = __webpack_public_path__ + "static/media/stop-14.5f79b32b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-14.svg
// module id = 1381
// module chunks = 0